import React, { Component } from "react";
import { getIncidentThread } from "../../../../ConversationSafe/ConversationSafeQuery";
import { Query } from "react-apollo";
import { MyContext } from "../../../../../context";
import { FontSizes, Spinner, ScrollablePane, CommandBarButton, Stack, DocumentCard, DocumentCardDetails, Text } from "office-ui-fabric-react/lib";

export default class IncidentHistory extends Component {
    static contextType = MyContext;
    constructor(props) {
        super(props);
        this.state = {};
    }

    getRiskRatingLabel = (rating) => {
        let label;
        switch (rating) {
            case "Info": label = this.context.getTranslation("compliance", "riskRatingInformation"); break;
            case "Adherence": label = this.context.getTranslation("compliance", "riskRatingAdherence"); break;
            case "Warn": label = this.context.getTranslation("compliance", "riskRatingWarning"); break;
            default: label = rating;
        }
        return label;
    }

    render() {
        return (
            <>
                <CommandBarButton
                    iconProps={{ iconName: "Back" }}
                    text={this.context.getTranslation("common", "back")}
                    style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon, backgroundColor: "transparent" }}
                    onClick={this.props.handleBack}
                />
                <div style={{ position: "relative", height: this.props.height, width: "100%", minHeight: "150px" }}>
                    <Query
                        query={getIncidentThread}
                        variables={{
                            id: this.props.incidentThreadId,
                            input: this.props.auth,
                        }}
                    >
                        {({ loading, error, data, refetch }) => {
                            if (loading) {
                                return (
                                    <Spinner
                                        label={this.context.getTranslation("common", "loading")}
                                        ariaLive="assertive"
                                        labelPosition="top"
                                        style={{ marginLeft: "auto", marginRight: "auto" }}
                                    />
                                );
                            }
                            if (error || data.getIncidentThread === null) {
                                return (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Text variant="mediumPlus">{this.context.getTranslation("filterPanel", "noResultsFound")}</Text>
                                    </div>
                                );
                            }
                            const incidentThread = data.getIncidentThread;

                            return (
                                <ScrollablePane>
                                    <Stack tokens={{ childrenGap: 16 }} style={{ width: "100%", paddingBottom: "10px" }}>
                                        {incidentThread.threads.map((threadItem, index) => {
                                            //console.log(threadItem)
                                            let action = "";
                                            let showPreviousStatus = true;
                                            let showCurrentStatus = true;
                                            let previousStatus = threadItem.previousStatus
                                            let currentStatus = threadItem.currentStatus
                                            switch (threadItem.statusType) {
                                                case "NEW": {
                                                    action = `${this.context.getTranslation("detailContainer", "addInCase")}`
                                                    showPreviousStatus = false;
                                                    showCurrentStatus = false;
                                                    break;
                                                }
                                                case "INCIDENT_STATUS": {
                                                    action = `${this.context.getTranslation("detailContainer", "changeStatusFrom")}`
                                                    previousStatus = this.context.getTranslation("compliance", threadItem.previousStatus.toLowerCase());
                                                    currentStatus = this.context.getTranslation("compliance", threadItem.currentStatus.toLowerCase());
                                                    break;
                                                }
                                                case "RISK_RATING_STATUS": {
                                                    action = `${this.context.getTranslation("detailContainer", "changeRiskRatingFrom")}`
                                                    previousStatus = this.getRiskRatingLabel(threadItem.previousStatus);
                                                    currentStatus = this.getRiskRatingLabel(threadItem.currentStatus);
                                                    break;
                                                }
                                                case "MOVE_TO": {
                                                    action = `${this.context.getTranslation("detailContainer", "moveToCase")}`
                                                    break;
                                                }
                                                case "FORWARD_TO": {
                                                    action = `${this.context.getTranslation("detailContainer", "forwardToUser")}`
                                                    showPreviousStatus = false;
                                                    break;
                                                }
                                            }
                                            return (
                                                <DocumentCard key={index} style={{ width: "100%", maxWidth: "none" }}>
                                                    <DocumentCardDetails>
                                                        <Stack horizontal tokens={{ childrenGap: 8 }} style={{ paddingTop: "16px", paddingBottom: "16px", paddingLeft: "16px" }}>
                                                            <Stack.Item grow>
                                                                {/*WHO*/}
                                                                <Text variant="medium" style={{ userSelect: "text", fontWeight: "600" }}>
                                                                    {threadItem.userName}{" "}
                                                                </Text>
                                                                {/*WHAT*/}
                                                                <Text variant="medium" style={{ userSelect: "text" }}>
                                                                    {action}{" "}
                                                                </Text>
                                                                {/*previousStatus*/}
                                                                {showPreviousStatus && <Text variant="medium" style={{ userSelect: "text", fontWeight: "600" }}>
                                                                    {previousStatus}{" "}
                                                                </Text>}
                                                                {/*scheduleSeparator*/}
                                                                {showPreviousStatus && <Text variant="medium" style={{ userSelect: "text" }}>
                                                                    {this.context.getTranslation("compliance", "scheduleSeparator")}{" "}
                                                                </Text>}
                                                                {/*currentStatus*/}
                                                                {showCurrentStatus && <Text variant="medium" style={{ userSelect: "text", fontWeight: "600" }}>
                                                                    {currentStatus}{" "}
                                                                </Text>}
                                                                {/*comment*/}
                                                                <Text variant="medium" style={{ userSelect: "text" }}>
                                                                    {threadItem.comment && `- ${threadItem.comment}`}
                                                                </Text>
                                                            </Stack.Item>
                                                            <Stack.Item>
                                                                <Text variant="medium" style={{ userSelect: "text", whiteSpace: "nowrap", marginRight: "16px" }}>
                                                                    {`${new Date(threadItem.lastModifiedDate).toLocaleString()}`}
                                                                </Text>
                                                            </Stack.Item>
                                                        </Stack>
                                                    </DocumentCardDetails>
                                                </DocumentCard>
                                            );
                                        })}
                                    </Stack>
                                </ScrollablePane>
                            );
                        }}
                    </Query>
                </div>
            </>
        );
    }
}
